import { lazy } from "react";
import { getSessionStorage, setSessionStorage } from "util/storageUtil";

// After a deploy, a tab that's still on the previous build will reference
// chunk hashes that no longer exist on the server (old build artifacts
// aren't retained), so any not-yet-loaded route fails with ChunkLoadError.
// One reload picks up the new index.html + matching chunk hashes and
// resolves it. The flag prevents a reload loop if the failure isn't
// actually stale-build related (offline, blocked request, etc).
//
// Deliberately never cleared on success: a page typically has several
// lazyWithRetry-wrapped chunks in flight at once, and clearing it as soon
// as any *one* of them resolves races the in-flight reload from a sibling
// chunk that failed — an unrelated chunk succeeding right before the
// reload lands would wipe the flag and re-arm another reload, looping
// forever. One automatic reload per tab session is the right ceiling;
// anything after that falls through to the ErrorBoundary's manual refresh.
const RELOAD_FLAG = "chunkReloadAttempted";

export const lazyWithRetry = (importer) =>
  lazy(async () => {
    try {
      return await importer();
    } catch (error) {
      if (!getSessionStorage(RELOAD_FLAG)) {
        setSessionStorage(RELOAD_FLAG, true);
        window.location.reload();
        // Reload is in flight — never resolve so Suspense keeps showing
        // its fallback instead of React trying to handle the rejection.
        return new Promise(() => {});
      }
      throw error;
    }
  });
